<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="dataFiltered"
        :fields="fields"
        name="reporteEncuestas.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
      <v-card>
        <v-card-title primary-title>
          Reportes Encuestas Realizadas
        </v-card-title>
        <v-card-title>
          <v-layout row>
            <v-flex mr-3 xs12 md3>
              <v-select
                :items="surveys"
                v-model="filter_survey"
                label="Encuesta"
                item-text="name"
                item-value="id"
                clearable
              ></v-select>
            </v-flex>
            <v-flex mr-3 xs12 md3>
              <v-select
                :items="apps"
                v-model="filter_app"
                label="App"
                item-text="name"
                item-value="id"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

         <v-data-table
            :headers="headers"
            :items="dataFiltered"
            :search="search"
            :loading="loading"
            item-key="aid"
          >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.encuesta }}</td>
                <td class="text-xs-center">{{ props.item.pregunta }}</td>
                <td class="text-xs-center">{{ props.item.tipo }}</td>
                <td class="text-xs-center">{{ props.item.opcion }}</td>
                <td class="text-xs-center">{{ props.item.valor }}</td>
                <td class="text-xs-center">{{ props.item.app }}</td>
                <td class="text-xs-center">{{ props.item.texto }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
      </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'survey-report-view',
    components: {
      'download-excel': JsonExcel,
    },
    data() {
      return {
        surveys: [],
        filter_survey: '',
        apps: [],
        filter_app: '',
        search: '',
        headers: [
          { text: 'Encuesta', align: 'center', value: 'encuesta' },
          { text: 'Pregunta', align: 'center', value: 'pregunta' },
          { text: 'Tipo', align: 'center', value: 'tipo' },
          { text: 'Opcion', align: 'center', value: 'opcion' },
          { text: 'Valor', align: 'center', value: 'valor' },
          { text: 'App', align: 'center', value: 'app' },
          { text: 'Texto', align: 'center', value: 'texto' },
        ],
        fields: {
          'Id': 'id',
          'Aid': 'aid',
          'Encuesta': 'encuesta',
          'Pregunta': 'pregunta',
          'Tipo Costo': 'tipo',
          'Opcion': 'opcion',
          'Valor': 'valor',
          'App': 'app',
          'Texto': 'texto',
        },
        search: '',
        loading: false,
        data: []
      }
    },
    computed: {
      dataFiltered() {
        let dataToFilter = this.data
        if (this.filter_survey && this.filter_survey !== '') {
          dataToFilter = dataToFilter.filter(data => data.id == this.filter_survey)
        }
        if (this.filter_app && this.filter_app !== '') {
          dataToFilter = dataToFilter.filter(data => data.app == this.filter_app)
        }
        return dataToFilter
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/surveys/report')
          .then(resp => {
            if (resp.status === 200) {
              const {
                surveys,
                apps,
                data,
              } = resp.data

              this.data = data
              this.surveys = surveys
              this.apps = [{
                id: 'NO', name: 'Sin App'
              }].concat(apps.map((_, i) => (
                { id: _.i, name: _.external_app }
              )))
            }
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/report.vue